import type { OrderSummary } from "types/mainTypes";
import {
	DRAWER_CLOSED_HEIGHT,
	DRAWER_TOTAL_HEIGHT,
	ORDER_STEP_1_SIZE_LARGE,
	ORDER_STEP_3_SMALL_ORDER_LIMIT,
	ORDER_STEP_5_SMALL_ORDER_LIMIT,
	REFILL_SUMMARY_SMALL_LIMIT,
} from "../../utils/designTokens";

export const getDrawerHeight = (
	open: boolean,
	currentOrderStep: number,
	orderSummary: OrderSummary | null,
	hasDiscountCode = false,
) => {
	if (open) {
		const dishCountLimit = currentOrderStep === 3 ? ORDER_STEP_3_SMALL_ORDER_LIMIT : ORDER_STEP_5_SMALL_ORDER_LIMIT;
		const listItemCount =
			// The aggregate count: OrderDishesList renders discounted types alongside full-price ones.
			(orderSummary?.orderDishTypesCount ?? 0) +
			// On step 5 the rating box band leaves no room, so the discount code row counts as a list item.
			(currentOrderStep === 5 && hasDiscountCode ? 1 : 0);

		const isFullHeightDrawer = currentOrderStep !== 1 && orderSummary && listItemCount > dishCountLimit;

		const isPartiallyOpenDrawer = currentOrderStep === 1 && open;

		if (isFullHeightDrawer) {
			return "100vh";
		}
		if (isPartiallyOpenDrawer) {
			return ORDER_STEP_1_SIZE_LARGE;
		}
		return DRAWER_TOTAL_HEIGHT;
	}
	return DRAWER_CLOSED_HEIGHT;
};

// The refill summary owns step 5 with its own rows (added + removed), not the order summary's (JID-2360).
export const isFullHeightRefillSummary = (open: boolean, currentOrderStep: number, refillSummaryRowCount: number) =>
	open && currentOrderStep === 5 && refillSummaryRowCount > REFILL_SUMMARY_SMALL_LIMIT;
